import {
  CREATE_WEBHOOKS, GET_WEBHOOKS, UPDATE_WEBHOOKS, DELETE_WEBHOOKS,
} from './constants';
import {PayloadUpdate, PayloadCreate} from './interfaces';

export function getWebhooksAction(payload: Record<string, any>) {
  return {
    type: GET_WEBHOOKS,
    payload,
  };
}

export function updateWebhooksActions(payload: PayloadUpdate) {
  return {
    type: UPDATE_WEBHOOKS,
    payload,
  };
}

export function createWebhooksActions(payload: PayloadCreate) {
  return {
    type: CREATE_WEBHOOKS,
    payload,
  };
}

export function deleteWebhooksActions(payload: {id: number}) {
  return {
    type: DELETE_WEBHOOKS,
    payload,
  };
}

